import { UserGroup, OfficeAppointments } from "../Components/index.js";

export default [
    {
        path: "/admin/office/setting/group",
        component: UserGroup,
        name: "office.setting.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/office/appointment",
        component: OfficeAppointments,
        name: "office.appointment.setting",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/letter/setting/group",
        component: UserGroup,
        name: "letter.setting.group",
        meta: {
            requiresAuth: true,
        },
    },
];
